export default __webpack_public_path__ + "static/media/downloadIconBlue.6502e820.svg";